import LlAudioSearchCombo from "./ll-audio-search-combo.marko";
import { pickReaderTaglineText } from "../../lib/reader-tagline.js";
import { readerHeroCoverAttrsFromPublicPath } from "../../lib/responsive-story-images.js";
import LlReaderPdfBtn from "./ll-reader-pdf-btn.marko";
import LlReaderPdfCard from "./ll-reader-pdf-card.marko";
import {
  READER_AUDIO_BOTTOM_OPT_OUT_SCRIPT,
  readerWrapClassNames,
} from "../../lib/reader-bottom-audio-ssr.js";
import ReaderShell from "./reader/reader-shell.marko";
import CoursePromoStrip from "./course-promo-strip.marko";
import ReaderMainTail from "./reader/reader-main-tail.marko";
import ReaderDataScripts from "./reader/reader-data-scripts.marko";
import { buildDialogReaderTextData } from "../../lib/reader-text-data-builders.js";
import LlReaderImageStagePlay from "./ll-reader-image-stage-play.marko";

<if=!input.data.dialog>
  <div class="container">
    <div class="empty">
      <div class="empty__icon">💬</div>
      <p class="empty__title">${input.data.notFoundTitle || ""}</p>
      <a href=input.data.basePath class="btn btn--outline" style="margin-top:var(--space-md)">← ${input.data.backLabel || ""}</a>
    </div>
  </div>
</if>
<else>
  <ReaderShell
    wrapClass=readerWrapClassNames({ hasAudio: !!(input.data.dialogAudioSrc || "").trim() })
    audioBottomOptOutScript=READER_AUDIO_BOTTOM_OPT_OUT_SCRIPT
    contentKind="dialog"
    contentId=(input.data.dialog.contentId || "")
    hasAudio=!!(input.data.dialogAudioSrc || "").trim()
    searchPlaceholder=(input.data.textTools?.labels?.dialogSearchPlaceholder || input.data.textTools?.labels?.searchPlaceholder || "")
    searchAriaLabel=(input.data.textTools?.labels?.textSearchAriaLabel || "")
    wordInfoEmptyLabel=(input.data.wordInfoEmptyLabel || "")
  >
        <div class="ll-reader-top-bar">
          <a class="ll-reader-back-link" href=input.data.basePath>← ${input.data.allLabel || ""}</a>
          <if=input.data.pdfUrl>
            <LlReaderPdfBtn
              pdfUrl=input.data.pdfUrl
              title=input.data.downloadPdfLabel
              ariaLabel=input.data.downloadPdfAriaLabel
              label=input.data.pdfAbbrevLabel
              deferredReveal=true
            />
          </if>
        </div>

        <if=(input.data.dialog.learnerTitle || input.data.dialog.translatedTitle)>
          <p class="title-aid title-aid--detail">${input.data.dialog.learnerTitle || input.data.dialog.translatedTitle}</p>
        </if>
        <div class="reader-title-row">
          <h1 class="reader-title">${input.data.dialog.targetTitle || input.data.dialog.title}</h1>
        </div>

        <if=(input.data.dialog.level || pickReaderTaglineText(input.data.dialog))>
          <div class="reader-desc-line">
            <if=input.data.dialog.level>
              <span class=["badge", "reader-desc-level", `badge--${(input.data.dialog.level || '').toLowerCase()}`]>${input.data.dialog.level}</span>
            </if>
            <if=pickReaderTaglineText(input.data.dialog)>
              <p class="reader-desc reader-desc--plain reader-desc--inline">${pickReaderTaglineText(input.data.dialog)}</p>
            </if>
          </div>
        </if>

        <if=input.data.dialogSceneImagePath>
          <for|hero| of=[readerHeroCoverAttrsFromPublicPath(input.data.dialogSceneImagePath)]>
            <div class="ll-story-hero ll-story-hero--reader-compact ll-story-hero--scene" id="ll-dialog-scene-hero" style="aspect-ratio:21/6">
              <div class="ll-story-hero__frame">
                <img
                  class="ll-story-hero__img"
                  src=hero.src
                  srcset=hero.srcSet
                  sizes=hero.sizes
                  alt=(input.data.dialog.targetTitle || input.data.dialog.title || "")
                  width=hero.width
                  height=hero.height
                  loading="eager"
                  fetchpriority="high"
                  decoding="sync"
                  onError="this.style.display='none';this.parentElement.innerHTML='<div class=&quot;ll-story-hero__fallback&quot;>💬</div>'"
                >
                <LlReaderImageStagePlay modifierClass="ll-reader-image-stage-play--main" ariaLabel=(input.data.audioPlayLabel || "Play audio")/>
              </div>
            </div>
          </for>
        </if>

        <div class="ll-reader-audio-dock-row">
          <div class="ll-reader-audio-dock" id="ll-reader-audio-dock">
            <if=!!(input.data.dialogAudioSrc || "").trim()>
              <LlAudioSearchCombo
                showSearch=false
                audioSrc=(input.data.dialogAudioSrc || "")
                audioDurationHint=(input.data.dialogAudioDurationHint != null ? input.data.dialogAudioDurationHint : "")
                audioDebug=(input.data.dialogAudioDebugMessage || "")
                audioTitle=(input.data.audioBadgeLabel || "")
                audioAriaLabel=(input.data.audioBadgeLabel || "")
                scrollFollowTitle=(input.data.scrollFollowTitle || "")
                scrollFollowAriaLabel=(input.data.scrollFollowAriaLabel || "")
              />
            </if>
          </div>
          <div class="ll-reader-voice-toggle-host" id="ll-reader-voice-toggle-host" hidden></div>
        </div>

        <div class="ll-meter-warning" id="ll-meter-warning" style="display:none">
          <span class="ll-meter-warning__text">${input.data.premiumGate?.labels?.meter?.warningBanner || ""}</span>
          <a
            class="ll-meter-warning__cta js-ll-purchase-cta"
            href="#"
            data-ll-analytics="0"
            data-ll-product=(input.data.premiumGate?.paywallPlans?.lern?.yearly?.plan?.product)
            data-ll-euros=(input.data.premiumGate?.paywallPlans?.lern?.yearly?.plan?.euros)
            data-ll-period=(input.data.premiumGate?.paywallPlans?.lern?.yearly?.plan?.period)
            data-ll-tier=(input.data.premiumGate?.paywallPlans?.lern?.yearly?.plan?.tier)
            data-ll-audience="lern"
            data-ll-pricing-tier-id=(input.data.premiumGate?.paywallPlans?.tierId)
          >${input.data.premiumGate?.labels?.meter?.ctaGuest || input.data.premiumGate?.labels?.meter?.cta || ""}</a>
        </div>

        <div id="ll-meter-inline-host"></div>

        <div class="dialog-lines reader-text" id="ll-text-root" data-ll-text-root>
          <for|row| of=(input.data.dialogRows || [])>
            <if=(row.kind === "narration")>
              <p class="dialog-narration">${row.text}</p>
            </if>
            <else>
              <div class=["dialog-line", row.align === "right" ? "dialog-line--pull-right" : "dialog-line--pull-left"]>
                <if=(row.speaker)><span class="dialog-line__name">${row.speaker}</span></if>
                <if=(row.textHtml)>
                  <div class="dialog-line__text">$!{row.textHtml}</div>
                </if>
                <else>
                  <div class="dialog-line__text">${row.text}</div>
                </else>
              </div>
            </else>
          </for>
        </div>

        <LlReaderPdfCard pdfUrl=input.data.pdfUrl uiLang=input.data.textTools?.uiLang/>

        <ReaderMainTail data=input.data/>
        <CoursePromoStrip class="ll-course-strip--reader"/>
  </ReaderShell>

  <ReaderDataScripts payload=buildDialogReaderTextData(input.data)/>

  <if=input.data.premiumGate>
    <html-script type="application/ld+json">
      $!{JSON.stringify({
        "@context": "https://schema.org",
        "@type": "Article",
        "headline": input.data.dialog.targetTitle || input.data.dialog.title || "",
        "description": pickReaderTaglineText(input.data.dialog) || input.data.dialog.translatedDescription || input.data.dialog.description || "",
        "isAccessibleForFree": !input.data.premiumGate.blocked,
        "hasPart": [
          {
            "@type": "WebPageElement",
            "isAccessibleForFree": true,
            "cssSelector": "#ll-text-root"
          },
          {
            "@type": "WebPageElement",
            "isAccessibleForFree": !(input.data.premiumGate.lockExercises),
            "cssSelector": "#ll-exercises-unit"
          }
        ]
      })}
    </html-script>
  </if>
</else>
